RivalIQ.apps.Site.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.SignupForm = Marionette.LayoutView.extend({
        template: false,
        ui: {
            submitBtn: '.signup-submit',
            errorDiv: '.error-div',
            errorString: '.error-string',
            errorStringLink: '.error-string-link',
            email: '.email',
            emailLabel: '.x-email-label',
            formContent: '.form-content',
            formSuccess: '.form-success',
            formDownloadDirect: '.form-download-direct',
            downloadBtn: '.x-download-asset'
        },
        regions: {
            extendedSignupForm: '.x-extended-signup-form'
        },
        events: function () {
            return {
                'click .signup-submit': 'buttonClick',
                'click .x-download-asset': 'onDownloadClick'
            };
        },
        initialize: function () {

            const me = this;
            // because we are not templating this view, the ui hash doesn't get turned into jquery selectors.
            // this call needs to be here because we're templating in the extended signup form later
            me.bindUIElements();


        },
        shown: function () {
            const me = this;

            if (me.shouldShowForm()) {
                me.ui.email.focus();

                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.V3ViewedSignup, {
                    testVariant: me.model.get('testVariant'),
                    buttonLocation: this.source,
                    'signupPage': encodeURIComponent(window.location.toString())
                });
            }
        },
        show: function () {
            const me = this;

            // we don't want to show the form when we already know who the user is
            if (me.shouldShowForm()) {
                me.ui.errorDiv.hide();
                me.ui.errorString.html('');
                me.ui.errorStringLink.hide();
                me.ui.email.val('');
                me.extendedSignupFormView = new views.ExtendedSignupForm({
                    model: me.model
                });
                me.extendedSignupForm.show(me.extendedSignupFormView);
            }

            const emailFieldLabel = me.model.get('emailFieldLabel');
            if (emailFieldLabel) {
                me.ui.emailLabel.text(emailFieldLabel);
            }

            me.postShow();
        },
        postShow: function () {
            // children can implement this if desired
        },
        shouldShowForm: function () {
            return true;
        },
        buttonClick: function (e) {

            const me = this;

            e.preventDefault();
            me.onSubmit();
        },

        // TODO this should be replaced with FormValidator in the future
        getFormAttributes: function () {
            const me = this;

            const formAttrs = {
                leadData: {},
                gdprMessage: me.$('.x-gdpr-msg').html()
            };

            return _.reduce(me.$('[name]').serializeArray(), function (obj, val) {
                const name = val.name;

                if (_.includes(['phoneNumber', 'companyName', 'companyTitle'], name)) {
                    obj.leadData[name] = val.value;
                } else if (_.includes(['termsAndConditions'], name)) {
                    obj[name] = (val.value === 'on');
                } else {
                    obj[name] = val.value;
                }

                return obj;
            }, formAttrs);
        },

        // TODO this should be replaced with FormValidator in the future
        showValidationErrors: function () {
            const me = this;
            _.each(me.model.validationError, function (error) {
                const input = me.$(`[name="${error[0]}"]`);
                input.parents('.form-group').addClass('has-error');
                input.parents('.form-group').find('.x-validation-error').text(error[1]).show();
            });
        },

        onSubmit: _.debounce(function () {
            const me = this;
            me.ui.submitBtn.button('loading');
            me.$('.x-validation-error').hide();
            me.$('.has-error').removeClass('has-error');

            const attrs = me.getFormAttributes();
            attrs.clickedPlanId = me.plan;

            RivalIQ.utils.hubSpot.augmentHubSpotFormData(me.model);

            const deferred = me.model.save(attrs);
            if (!deferred) {
                me.ui.submitBtn.button('reset');
                return me.showValidationErrors();
            }
            deferred
                .done(_.bind(me.onSuccess, me))
                .fail(_.bind(me.handleError, me));
        }, 500, {
            leading: true
        }),
        onSuccess: function () {

            const me = this;

            const accountGroupId = me.model.get('accountGroupId') || '';
            const quidBrandingQueryString = accountGroupId === 80 ? '?quid=true' : '';

            const server = _.get(window.RivalIQEnv, ['urlBasepath']);

            const nextPage = (server ? `${server}/signupSuccess${quidBrandingQueryString}` : `/signupSuccess${quidBrandingQueryString}`);

            const redirectToNextPage = function () {
                if (window.parent) {
                    window.parent.location = nextPage;
                } else {
                    window.location = nextPage;
                }
            };

            setTimeout(redirectToNextPage, 3000);

            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.V3SignedUp, {
                buttonLocation: me.source,
                signupPage: encodeURIComponent(window.location.toString())
            });

            RivalIQ.execute('tracking:identify', me.ui.email.val());
        },
        handleError: function (xhr) {
            const me = this;
            let eString = '';
            let fieldName = null;

            const errorName = _.get(xhr, ['responseJSON', 'RESTerror', 'name']);
            switch (errorName) {
                case 'EmailAlreadyExistsError':
                    eString = 'That email has already been registered with Rival IQ. ';
                    break;
                case 'BadEmailAddressError':
                    eString = `That email isn't valid. Try again.`;
                    fieldName = 'email';
                    break;
                case 'DisposableEmailAddressError':
                    eString = 'Please use your work email to create your account.';
                    fieldName = 'email';
                    break;
                default:
                    eString = 'Error creating account. Please try again.';
            }

            if (fieldName) {
                const input = me.$(`[name="${fieldName}"]`);
                input.parents('.form-group').addClass('has-error');
                input.parents('.form-group').find('.x-validation-error').text(eString).show();
            } else {
                me.ui.errorString.html(eString);
                me.ui.errorDiv.show();
            }


            me.ui.submitBtn.button('reset');

            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.V3SignupError, {
                buttonLocation: me.source,
                'signupPage': encodeURIComponent(window.location.toString())
            });
        }
    });
});
